import { render, staticRenderFns } from "./AdmissionFormSections.vue?vue&type=template&id=31fc2270&scoped=true"
import script from "./AdmissionFormSections.vue?vue&type=script&lang=js"
export * from "./AdmissionFormSections.vue?vue&type=script&lang=js"
import style0 from "./AdmissionFormSections.vue?vue&type=style&index=0&id=31fc2270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc2270",
  null
  
)

export default component.exports